import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getBusinessUsers } from "../../../actions/admin/user";
import { ON_GET_BUSINESS_USER } from "../../../actions/types";
import AdminPage from "../_components/AdminPage";
import AdminTable from "../_components/AdminTable";
import BusinessUserItem from "./BusinessUseritem";
import Filter from "./_components/Filter";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Name", width: "tw:w-[240px]", sortField: "name" },
  { key: "email", title: "Email", width: "tw:w-[280px]", sortField: "email" },
  { key: "paymentType", title: "Payment Type", width: "tw:w-[180px]", skeleton: "badge" },
  { key: "status", title: "Status", width: "tw:w-[220px]", sortField: "status", skeleton: "badge" },
  { key: "iata", title: "IATA Discount Rate", width: "tw:w-[200px]" },
  { key: "lastBooked", title: "Last Booked", width: "tw:w-[160px]" },
  { key: "createdOn", title: "Created Date", width: "tw:w-[180px]", sortField: "date" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const BusinessUserList = () => {
  const businessuser = useSelector((state) => state.businessuser);
  const { loading, businessUsers } = businessuser;
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState({
    sortBy: "asc",
    orderBy: "date",
    page: 1,
    limit: 100,
    disableCalculateTotal: false,
    draw: 1,
    id: "",
    role: "business",
    status: "",
  });

  // debounce effect
  useEffect(() => {
    dispatch({
      type: ON_GET_BUSINESS_USER,
    });
    const handler = setTimeout(() => {
      dispatch(getBusinessUsers({ ...query, search }));
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [dispatch, query, search]);

  const requestSort = (key) => {
    setQuery((prev) => ({
      ...prev,
      orderBy: key,
      sortBy: prev.orderBy === key && prev.sortBy === "asc" ? "desc" : "asc",
    }));
  };

  const rows = businessUsers?.data || [];

  return (
    <AdminPage title="Business User List">
      <Filter
        search={search}
        setSearch={setSearch}
        onApplyStatus={(status) => setQuery((prev) => ({ ...prev, status }))}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1620}
        sortConfig={{ key: query.orderBy, direction: query.sortBy }}
        onSort={requestSort}
        loading={loading}
        skeletonRowCount={10}
        isEmpty={!rows.length}
        emptyText="No users found."
      >
        {rows.map((item, index) => (
          <BusinessUserItem key={item._id} user={item} count={index} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default BusinessUserList;
